import icSocChargeTransactionOnDate from 'assets/images/SOC/ic_soc_charge_transaction_on_date.svg';
import icSocChargeTransactionOnMonth from 'assets/images/SOC/ic_soc_charge_transaction_on_month.svg';
import icSocEnergyOnDate from 'assets/images/SOC/ic_soc_energy_on_date.svg';
import icSocEnergyOnMonth from 'assets/images/SOC/ic_soc_energy_on_month.svg';
import icSocRevenueOnDate from 'assets/images/SOC/ic_soc_revenue_on_date.svg';
import icSocRevenueOnMonth from 'assets/images/SOC/ic_soc_revenue_on_month.svg';
import icSocDriver from 'assets/images/SOC/ic_soc_driver.svg';
import icSocStation from 'assets/images/SOC/ic_soc_station.svg';
import imgSocTopLeft from 'assets/images/SOC/img_soc_topleft.png';
import imgSocTopRight from 'assets/images/SOC/img_soc_topright.png';
import ChargeHelper, { ChargeConstants } from 'features/Charge/chargeHelper';
import SystemHelper from 'features/System/systemHelper';
import BarChart from 'general/components/quybka/Charts/BarChart';
import DoughnutChartJS from 'general/components/quybka/Charts/DoughnutChartJS';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import useRouter from 'hooks/useRouter';
import _ from 'lodash';
import { useEffect, useMemo, useRef, useState } from 'react';
import Gauge from 'react-gauge-component';
import SOCHeaderView from '../SOCHeaderView';
import SOCStationMapView from '../SOCStationMapView';
import moment from 'moment';
import AppColors from 'general/constants/AppColors';

SOCHomeView.propTypes = {};

function SOCHomeView(props) {
  // MARK: ---- PROPERTIES ----
  const router = useRouter();
  const pointChartRef = useRef();
  const notificationTitleRef = useRef();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const [socData, setSocData] = useState({});
  const [chartData, setChartData] = useState({});
  const [systemLogList, setSystemLogList] = useState([]);
  useEffect(() => {
    getSocData();
    getSystemLogData();
    getDailyData();
    const interval = setInterval(() => {
      getSocData();
      getSystemLogData();
    }, 5000);

    return () => {
      clearInterval(interval);
    };
  }, []);
  const [chartDataByVehicle, setChartDataByVehicle] = useState();
  useEffect(() => {
    if (!chartData) return;
    const chartDataByVehicle = processVehicleData(chartData?.dailyByVehicleType);
    setChartDataByVehicle(chartDataByVehicle);
  }, [chartData])
  // const chartDataByVehicle = useMemo(() => {
  //   return processVehicleData(chartData?.dailyByVehicleType);
  // }, [chartData])
  const getTotalDataInMonth = (data) => {
    const currentMonth = moment().month();
    const currentYear = moment().year();

    const transactionByDateFull = Utils.mergeDataByDate(
      data?.transactionCount?.CAR,
      data?.transactionCount?.BIKE,
      'transactions'
    );
    const transactionCount = transactionByDateFull?.reduce((sum, item) => {
      const date = new Date(item.date);
      if (date.getMonth() === currentMonth && date.getFullYear() === currentYear) {
        sum += item.transactions || 0;
      }
      return sum;
    }, 0) || 0;

    const energyByDateFull = Utils.mergeDataByDate(
      data?.totalEnergy?.CAR,
      data?.totalEnergy?.BIKE,
      'energy'
    );

    const totalEnergy = energyByDateFull?.reduce((sum, item) => {
      const date = new Date(item.date);
      if (date.getMonth() === currentMonth && date.getFullYear() === currentYear) {
        sum += item.energy || 0;
      }
      return sum;
    }, 0) || 0;

    const revenueByDateFull = Utils.mergeDataByDate(
      data?.totalRevenue?.CAR,
      data?.totalRevenue?.BIKE,
      'amount'
    );
    const totalRevenue = revenueByDateFull?.reduce((sum, item) => {
      const date = new Date(item.date);
      if (date.getMonth() === currentMonth && date.getFullYear() === currentYear) {
        sum += item.amount || 0;
      }
      return sum;
    }, 0) || 0;

    return {
      transactionCount,
      totalEnergy: (totalEnergy / 1000)?.toFixed(3),
      totalRevenue,
    };
  };
  const statisticItems = useMemo(() => {
    return [
      {
        icon: icSocEnergyOnDate,
        name: 'Số điện sạc trong ngày',
        value: Utils.isValid(socData?.totalEnergy) ? Utils.formatNumber((socData?.totalEnergy / 1000).toFixed(3)) : 0,
        unit: 'kWh',
      },
      {
        icon: icSocRevenueOnDate,
        name: 'Doanh thu trong ngày',
        value: Utils.formatNumber(socData?.revenue ?? 0),
        unit: 'VNĐ',
      },
      {
        icon: icSocChargeTransactionOnDate,
        name: 'Số phiên sạc trong ngày',
        value: Utils.isValid(socData?.transactionCount)
          ? Utils.formatNumber(socData?.transactionCount)
          : 0,
        unit: 'Phiên',
      },
      {
        icon: icSocEnergyOnMonth,
        name: 'Số điện sạc trong tháng',
        value: Utils.formatNumber(getTotalDataInMonth(chartDataByVehicle)?.totalEnergy ?? 0),
        unit: 'kWh',
      },
      {
        icon: icSocRevenueOnMonth,
        name: 'Doanh thu trong tháng',
        value: Utils.formatNumber(getTotalDataInMonth(chartDataByVehicle)?.totalRevenue ?? 0),
        unit: 'VNĐ',
      },
      {
        icon: icSocChargeTransactionOnMonth,
        name: 'Số phiên sạc trong tháng',
        value: Utils.formatNumber(getTotalDataInMonth(chartDataByVehicle)?.transactionCount ?? 0),
        unit: 'Phiên',
      },
      {
        icon: <></>,
        name: '',
        value: null,
        unit: '',
      },
      {
        icon: icSocDriver,
        name: 'Tổng số khách hàng',
        value: Utils.isValid(socData?.customerCount)
          ? Utils.formatNumber(socData?.customerCount)
          : 0,
        unit: 'KH',
      },
      {
        icon: icSocStation,
        name: 'Tổng số trạm sạc',
        value: Utils.isValid(socData?.stationsCount)
          ? Utils.formatNumber(socData?.stationsCount)
          : 0,
        unit: 'Trạm',
      },
    ];
  }, [socData]);
  const gaugeChartEl = useMemo(() => {
    const totalPower = Utils.isValid(socData?.maxPower) ? socData?.maxPower / 1000 : 0;
    const chargingPower = Utils.isValid(socData?.chargingPower) ? socData?.chargingPower / 1000 : 0;
    const value = totalPower > 0 ? (chargingPower / totalPower) * 100 : 0;
    return (
      <Gauge
        type="radial"
        style={{
          width: '100%',
        }}
        value={value}
        minValue={0}
        maxValue={100}
        colors={['rgba(135, 255, 11, 1)', 'rgba(249, 183, 0, 1)', 'rgba(251, 33, 21, 1)']}
        labels={{
          tickLabels: {
            type: 'outer',
            defaultTickValueConfig: {
              formatTextValue: (value) => value + '',
            },
            ticks: [
              { value: 0 },
              { value: 10 },
              { value: 20 },
              { value: 30 },
              { value: 40 },
              { value: 50 },
              { value: 60 },
              { value: 70 },
              { value: 80 },
              { value: 90 },
              { value: 100 },
            ],
          },
          valueLabel: {
            style: {
              fontSize: '32px',
              fontWeight: 700,
              fill: 'rgba(255, 255, 255, 0.8)',
              textShadow: 'black 1px 1px 0px, black 0px 0px 2.5em, black 0px 0px 0.2em',
            },
          },
        }}
        arc={{
          gradient: true,
          width: 0.14,
        }}
        pointer={{
          type: 'needle',
          elastic: true,
          color: 'rgba(142, 142, 142, 1)',
        }}
      />
    );
  }, [socData]);
  const vehicleStatistic = useMemo(() => {
    return {
      car:
        _.find(
          socData?.vehicleCount,
          (item) => item?.vehicleType === ChargeConstants.VehicleType.CAR
        )?.vehicleCount ?? 0,
      bike:
        _.find(
          socData?.vehicleCount,
          (item) => item?.vehicleType === ChargeConstants.VehicleType.BIKE
        )?.vehicleCount ?? 0,
    };
  }, [socData]);
  const pointStatistic = useMemo(() => {
    return {
      [ChargeConstants.ChargePointStatus.AVAILABLE]:
        _.find(
          socData?.chargePointCount,
          (item) => item.status === ChargeConstants.ChargePointStatus.AVAILABLE
        )?.chargePointCount ?? 0,
      [ChargeConstants.ChargePointStatus.BUSY]:
        _.find(
          socData?.chargePointCount,
          (item) => item.status === ChargeConstants.ChargePointStatus.BUSY
        )?.chargePointCount ?? 0,
      [ChargeConstants.ChargePointStatus.MAINTAINING]:
        _.find(
          socData?.chargePointCount,
          (item) => item.status === ChargeConstants.ChargePointStatus.MAINTAINING
        )?.chargePointCount ?? 0,
      [ChargeConstants.ChargePointStatus.FAULT]:
        _.find(
          socData?.chargePointCount,
          (item) => item.status === ChargeConstants.ChargePointStatus.FAULT
        )?.chargePointCount ?? 0,
      [ChargeConstants.ChargePointStatus.DISCONNECTED]:
        _.find(
          socData?.chargePointCount,
          (item) => item.status === ChargeConstants.ChargePointStatus.DISCONNECTED
        )?.chargePointCount ?? 0,
    };
  }, [socData]);
  const stationMapViewEl = useMemo(() => {
    return <SOCStationMapView stationList={socData?.stations} />;
  }, [socData?.stations?.length]);
  const pointChartEl = useMemo(() => {
    return (
      <DoughnutChartJS
        showTitle={false}
        showLegend={false}
        labels={[
          ChargeHelper.Utils.getChargePointStatusName(ChargeConstants.ChargePointStatus.AVAILABLE),
          ChargeHelper.Utils.getChargePointStatusName(ChargeConstants.ChargePointStatus.BUSY),
          ChargeHelper.Utils.getChargePointStatusName(ChargeConstants.ChargePointStatus.MAINTAINING),
          ChargeHelper.Utils.getChargePointStatusName(ChargeConstants.ChargePointStatus.FAULT),
          ChargeHelper.Utils.getChargePointStatusName(ChargeConstants.ChargePointStatus.DISCONNECTED),
        ]}
        datasets={[
          {
            data: [
              pointStatistic?.[ChargeConstants.ChargePointStatus.AVAILABLE],
              pointStatistic?.[ChargeConstants.ChargePointStatus.BUSY],
              pointStatistic?.[ChargeConstants.ChargePointStatus.MAINTAINING],
              pointStatistic?.[ChargeConstants.ChargePointStatus.FAULT],
              pointStatistic?.[ChargeConstants.ChargePointStatus.DISCONNECTED]
            ],
            borderColor: [
              'rgba(10, 24, 57, 1)',
              'rgba(10, 24, 57, 1)',
              'rgba(10, 24, 57, 1)',
              'rgba(10, 24, 57, 1)',
              'rgba(10, 24, 57, 1)',
            ],
            backgroundColor: [
              SystemHelper.Utils.SOC.getSocPointStatusColor(ChargeConstants.ChargePointStatus.AVAILABLE),
              SystemHelper.Utils.SOC.getSocPointStatusColor(ChargeConstants.ChargePointStatus.BUSY),
              SystemHelper.Utils.SOC.getSocPointStatusColor(ChargeConstants.ChargePointStatus.MAINTAINING),
              SystemHelper.Utils.SOC.getSocPointStatusColor(ChargeConstants.ChargePointStatus.FAULT),
              SystemHelper.Utils.SOC.getSocPointStatusColor(ChargeConstants.ChargePointStatus.DISCONNECTED),
            ],
            borderWidth: 3,
          },
        ]}
      />
    );
  }, [pointStatistic]);
  const chartRevenueByDateEl = useMemo(() => {
    const sortedRevenueByDate = _.orderBy(socData?.dailyRevenue ?? [], ['date'], ['desc']);
    const revenueByDate = _.slice(sortedRevenueByDate, 0, 10).reverse();
    let labels = revenueByDate.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = revenueByDate.map((item) => item.kpiValue ?? 0);

    if (revenueByDate.length > 31) {
      const groupedData = _.groupBy(revenueByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels.map((label) => {
        const total = groupedData[label].reduce((sum, item) => sum + item.kpiValue, 0);
        return total;
      });
    }

    return (
      <BarChart
        title="Doanh thu"
        unit="VNĐ"
        labels={labels}
        data={data}
        color="rgba(30, 245, 223, 0.5)"
        hoverColor="rgba(30, 245, 223, 1)"
        showLine={true}
      />
    );
  }, [socData]);
  const chartTransactionByDateEl = useMemo(() => {
    const transactionByDateFull = Utils.mergeDataByDate(
      chartDataByVehicle?.transactionCount?.CAR,
      chartDataByVehicle?.transactionCount?.BIKE,
      'transactions'
    );
    const sortedTransactionByDate = _.orderBy(
      transactionByDateFull ?? [],
      ['date'],
      ['desc']
    );
    const transactionByDate = _.slice(sortedTransactionByDate, 0, 10).reverse();
    let labels = transactionByDate.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = transactionByDate.map((item) => item.transactions ?? 0);

    if (transactionByDate.length > 31) {
      const groupedData = _.groupBy(transactionByDate, (item) =>
        moment(item.date).format('MM/YYYY')
      );
      labels = Object.keys(groupedData);
      data = labels.map((label) => {
        const total = groupedData[label].reduce((sum, item) => sum + item.transactions, 0);
        return total;
      });
    }

    return (
      <BarChart
        title="Phiên"
        unit="phiên"
        labels={labels}
        data={data}
        color="rgba(30, 245, 223, 0.5)"
        hoverColor="rgba(30, 245, 223, 1)"
      />
    );
  }, [chartData, chartDataByVehicle]);
  const chartEnergyByDateEl = useMemo(() => {
    const energyByDateFull = Utils.mergeDataByDate(
      chartDataByVehicle?.totalEnergy?.CAR,
      chartDataByVehicle?.totalEnergy?.BIKE,
      'energy'
    );
    const sortedTransactionByDate = _.orderBy(energyByDateFull ?? [], ['date'], ['desc']);
    const energyByDate = _.slice(sortedTransactionByDate, 0, 10).reverse();
    let labels = energyByDate.map((item) => Utils.formatDateTimeToString(item.date, 'DD'));
    let data = energyByDate?.map((item) => ((item.energy ?? 0) / 1000).toFixed(3));

    if (energyByDate.length > 31) {
      const groupedData = _.groupBy(energyByDate, (item) => moment(item.date).format('MM/YYYY'));
      labels = Object.keys(groupedData);
      data = labels.map((label) => {
        const total = groupedData[label].reduce((sum, item) => sum + item.energy, 0);
        return (total / 1000).toFixed(3);
      });
    }

    return (
      <BarChart
        title="Điện sạc"
        unit="kWh"
        labels={labels}
        data={data}
        color="rgba(30, 245, 223, 0.5)"
        hoverColor="rgba(30, 245, 223, 1)"
      />
    );
  }, [chartData, chartDataByVehicle]);

  // MARK: ---- METHODS ----
  const getSocData = () => {
    SystemHelper.API.SOC.requestGetSocData().then((res) => {
      setSocData(res);
    });
  };
  const getDailyData = () => {
    ChargeHelper.API.Dashboard.requestGetDailyData({}).then((res) => {
      setChartData(res ?? {});
    });
  };
  const getSystemLogData = () => {
    ChargeHelper.API.SystemLog.requestGetSystemLogList({
      page: 0,
      limit: AppConfigs.defaultPageLimit,
    }).then((res) => {
      setSystemLogList(res?.messages ?? []);
    });
  };
  const processVehicleData = (data) => {
    if (!data) return;
    const transactionCount = {
      CAR: [],
      BIKE: []
    };
    const totalRevenue = {
      CAR: [],
      BIKE: []
    };
    const totalEnergy = {
      CAR: [],
      BIKE: []
    };

    data?.forEach(day => {
      const date = day.date;

      const carData = day.vehicleTypes.find(v => v.vehicleType === "CAR");
      const bikeData = day.vehicleTypes.find(v => v.vehicleType === "BIKE");

      transactionCount.CAR.push({
        date: date,
        transactions: carData.transactionCount || 0
      });
      transactionCount.BIKE.push({
        date: date,
        transactions: bikeData.transactionCount || 0
      });

      totalRevenue.CAR.push({
        date: date,
        amount: carData.totalRevenue || 0
      });
      totalRevenue.BIKE.push({
        date: date,
        amount: bikeData.totalRevenue || 0
      });

      totalEnergy.CAR.push({
        date: date,
        energy: carData.totalEnergy || 0
      });
      totalEnergy.BIKE.push({
        date: date,
        energy: bikeData.totalEnergy || 0
      });
    });

    return {
      transactionCount,
      totalRevenue,
      totalEnergy
    };
  }
  const buildSocCard = (contentEl, hasPadding = true) => {
    return (
      <div
        className="h-100"
        style={{
          border: `1px solid #1B4E93`,
          borderRadius: `${windowSize.width * 0.0042}px`,
          padding: hasPadding ? `${windowSize.width * 0.006}px` : '0px',
          boxShadow: '0px 0px 25px 0px rgba(25, 104, 255, 0.3) inset',
          background:
            'linear-gradient(360deg, rgba(34, 127, 253, 0.199109) 0%, rgba(0, 108, 255, 0.0001) 100%)',
        }}
      >
        {contentEl}
      </div>
    );
  };
  const buildSocCardTitle = (title, unit) => {
    return (
      <div
        className="w-100 d-flex"
        style={{
          height: `${windowSize.width * 0.0151}px`,
          gap: `${windowSize.width * 0.004}px`,
        }}
      >
        <div
          className="h-100"
          style={{
            backgroundColor: 'rgba(30, 245, 223, 1)',
            width: '8px',
          }}
        ></div>
        <div
          className="h-100 flex-grow-1 d-flex align-items-center d-flex align-items-center justify-content-between"
          style={{
            paddingLeft: `${windowSize.width * 0.004}px`,
            paddingBottom: `${windowSize.width * 0.001}px`,
            background:
              'linear-gradient(270deg, rgba(31, 76, 162, 0.0001) 0%, rgba(31, 76, 162, 0.5) 100%)',
          }}
        >
          <span
            style={UIHelper.buildFontStyle(
              '700',
              `${windowSize.width * 0.0073}px`,
              'rgba(255, 255, 255, 0.8)'
            )}
          >
            {title}
          </span>
          <span
            style={UIHelper.buildFontStyle(
              '700',
              `${windowSize.width * 0.0073}px`,
              'rgba(255, 255, 255, 0.8)'
            )}
          >
            {unit}
          </span>
        </div>
      </div>
    );
  };
  const buildStatisticItem = (icon, name, value, unit) => {
    return (
      <div className="d-flex align-items-center gap-2 h-100">
        <div
          style={{
            height: `${windowSize.height * 0.044}px`,
            aspectRatio: '1/1',
          }}
        >
          <img src={icon} alt={name} className="w-100 h-100" />
        </div>
        <div className="flex-grow-1 d-flex flex-column align-items-start justify-content-center">
          <div className="w-100 d-flex align-items-center justify-content-between">
            <span style={UIHelper.buildFontStyle('700', `${windowSize.height * 0.025}px`, 'white')}>
              {value}
            </span>
            <span
              style={UIHelper.buildFontStyle('700', `${windowSize.height * 0.013}px`, '#87FF0B')}
            >
              {unit}
            </span>
          </div>
          <span
            style={UIHelper.buildFontStyle(
              '700',
              `${windowSize.height * 0.013}px`,
              'rgba(255, 255, 255, 0.5)'
            )}
          >
            {name}
          </span>
        </div>
      </div>
    );
  };
  const buildStationPinStatus = (status, total) => {
    return (
      <div className="d-flex align-items-center gap-2">
        <i
          className={`fa-solid fa-location-pin`}
          style={{
            color: SystemHelper.Utils.SOC.getSocStationStatusColor(status),
          }}
        />
        <span style={UIHelper.buildFontStyle('400', `${windowSize.width * 0.007}px`, 'white')}>
          <span
            style={UIHelper.buildFontStyle(
              '600',
              `${windowSize.width * 0.0073}px`,
              SystemHelper.Utils.SOC.getSocStationStatusColor(status)
            )}
          >
            {total}
          </span>{' '}
          {ChargeHelper.Utils.getChargeStationStatusName(status)}
        </span>
      </div>
    );
  };
  const buildChartPointStatus = (status, total) => {
    return (
      <div className="d-flex align-items-center gap-2">
        <i
          className={`fa-solid fa-square`}
          style={{
            color: SystemHelper.Utils.SOC.getSocPointStatusColor(status),
            fontSize: `${windowSize.width * 0.009}px`
          }}
        />
        <span style={UIHelper.buildFontStyle('400', `${windowSize.width * 0.0073}px`, 'white')}>
          <span
            style={UIHelper.buildFontStyle(
              '600',
              `${windowSize.width * 0.0073}px`,
              SystemHelper.Utils.SOC.getSocPointStatusColor(status)
            )}
          >
            {total}
          </span>{' '}
          {ChargeHelper.Utils.getChargePointStatusName(status)}
        </span>
      </div>
    );
  };
  const buildVehicleStatisticItem = (name, value) => {
    return (
      <div className="d-flex flex-column align-items-center">
        <span
          style={UIHelper.buildFontStyle(
            '700',
            `${windowSize.width * 0.0083}px`,
            'rgba(255, 255, 255, 1)'
          )}
        >
          {name}
        </span>
        <span
          style={UIHelper.buildFontStyle(
            '700',
            `${windowSize.width * 0.0125}px`,
            'rgba(135, 255, 11, 1)'
          )}
        >
          {value}
        </span>
        <span
          style={UIHelper.buildFontStyle(
            '600',
            `${windowSize.width * 0.0083}px`,
            'rgba(255, 255, 255, 0.5)'
          )}
        >
          Chiếc
        </span>
      </div>
    );
  };
  const buildVerticalDivider = (height = windowSize.width * 0.016) => {
    return (
      <div
        style={{
          height: `${height}px`,
          width: '1px',
          background:
            'linear-gradient(180deg, rgba(9, 103, 233, 0) 0%, #017AFF 50%, rgba(9, 103, 233, 0) 100%)',
        }}
      ></div>
    );
  };
  const buildMessageLogItem = (row, showDivider = true) => {
    return (
      <div
        className="d-flex align-items-center justify-content-between gap-3"
        style={{
          padding: `${windowSize.width * 0.006}px`,
          borderBottom: showDivider ? `1px solid rgba(255, 255, 255, 0.1)` : '',
        }}
      >
        <div className="flex-grow-1 d-flex align-items-center gap-2">
          <i
            className={SystemHelper.Utils.SOC.getSocSystemLogIcon(row?.level)}
            style={{
              color: SystemHelper.Utils.SOC.getSocSystemLogColor(row?.level),
              fontSize: `${windowSize.width * 0.0125}px`,
            }}
          />
          <span
            className="text-ellipsis-1-lines"
            style={UIHelper.buildFontStyle(
              '400',
              `${windowSize.width * 0.007}px`,
              'rgba(255, 255, 255, 1)'
            )}
          >
            {row?.title}
          </span>
        </div>
        <span
          style={{
            ...UIHelper.buildFontStyle(
              '400',
              `${windowSize.width * 0.006}px`,
              'rgba(255, 255, 255, 0.5)'
            ),
            whiteSpace: 'nowrap',
          }}
        >
          {Utils.formatDateTimeToString(row?.createdAt, 'DD/MM/YYYY - HH:mm')}
        </span>
      </div>
    );
  };

  return (
    <div className="w-100 h-100 position-relative">
      {/* ban do tram sac */}
      {stationMapViewEl}

      {/* overlay view */}
      <div
        className="position-absolute top-0 left-0 w-100 h-100 d-flex flex-column"
        style={{
          zIndex: 100,
          pointerEvents: 'none',
          background: 'radial-gradient(circle, rgba(0,0,0,0) 0%, rgba(0,0,0,0) 30%, rgba(0,0,0,0.85) 55%, rgba(0,0,0,1) 70%)',
        }}
      >
        {/* header */}
        <SOCHeaderView padding={windowSize.width * 0.008} windowSize={windowSize} />
        {/* content */}
        <div
          className="flex-grow-1 d-flex"
          style={{
            marginLeft: `${windowSize.width * 0.008}px`,
            marginRight: `${windowSize.width * 0.008}px`,
            marginBottom: `${windowSize.width * 0.008}px`,
          }}
        >
          {/* left - thong ke he thong */}
          <div
            className="h-100 d-flex flex-column"
            style={{
              width: `${windowSize.width * 0.19}px`,
              pointerEvents: 'visible',
            }}
          >
            {/* tieu de */}
            <div
              className="position-relative w-100"
              style={{
                aspectRatio: '342/39',
              }}
            >
              <img
                src={imgSocTopLeft}
                alt="decor-top-left"
                className="w-100 h-100"
                style={{
                  objectFit: 'contain',
                }}
              />
              <div
                className="position-absolute left-0 top-0 h-100 d-flex align-items-center"
                style={{
                  paddingBottom: '0.5%',
                  paddingLeft: '5%',
                }}
              >
                <span
                  className="text-uppercase"
                  style={UIHelper.buildFontStyle('700', `${windowSize.width * 0.009}px`, 'white')}
                >
                  Thống kê hệ thống
                </span>
              </div>
            </div>
            {/* thong ke */}
            <div
              className="flex-grow-1 position-relative"
              style={{
                paddingTop: `${windowSize.width * 0.004}px`,
                gap: `${windowSize.width * 0.004}px`,
              }}
            >
              <div
                className="flex-grow-1 d-flex flex-column"
                style={{
                  gap: `${windowSize.width * 0.0035}px`,
                  height: `calc(100% - ${(windowSize.width * 0.19 * 300) / 357}px - ${windowSize.width * 0.004
                    }px)`,
                }}
              >
                {statisticItems.map((item, index) => {
                  if (!item?.name?.length) {
                    return (
                      <div style={{ borderTop: `1px solid ${AppColors.info}` }} />
                    )
                  }
                  return (
                    <div
                      key={index}
                      className="flex-grow-1"
                      style={{
                        height: `${windowSize.height * 0.056}px`,
                      }}
                    >
                      {buildSocCard(
                        buildStatisticItem(item.icon, item.name, item.value, item.unit)
                      )}
                    </div>
                  );
                })}
              </div>

              {/* cong suat */}
              <div
                className="w-100 position-absolute bottom-0 left-0"
                style={{
                  aspectRatio: '357/300',
                }}
              >
                {buildSocCard(
                  <div className="h-100 d-flex flex-column">
                    {buildSocCardTitle('Công suất')}
                    <div
                      className="flex-grow-1 d-flex align-items-center justify-content-center"
                    >
                      <div
                        style={{
                          width: `${windowSize.width * 0.15}px`,
                        }}
                      >
                        {gaugeChartEl}
                      </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-center">
                      <span
                        className="text-center"
                        style={UIHelper.buildFontStyle(
                          '700',
                          `${windowSize.width * 0.0083}px`,
                          'rgba(255, 255, 255, 0.8)'
                        )}
                      >
                        TỔNG CÔNG SUẤT HỆ THỐNG:{' '}
                        {Utils.isValid(socData?.maxPower)
                          ? Utils.formatNumber((socData?.maxPower / 1000).toFixed(0))
                          : 0}{' '}
                        kW
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* center */}
          <div
            className="flex-grow-1 h-100 d-flex flex-column justify-content-between gradient-bottom-view"
            style={{ pointerEvents: 'none' }}
          >
            <div
              style={{
                padding: `${windowSize.width * 0.008}px`,
              }}
            >
              <div
                className="d-flex flex-wrap gap-4 justify-content-around overflow-hidden"
                style={{
                  border: '1px solid rgba(1, 122, 255, 1)',
                  background: 'rgba(7, 25, 58, 1)',
                  padding: `0px ${windowSize.width * 0.006}px`,
                }}
              >
                {buildStationPinStatus(
                  ChargeConstants.ChargeStationStatus.NORMAL,
                  _.countBy(socData?.stations, 'status')?.[
                  ChargeConstants.ChargeStationStatus.NORMAL
                  ] ?? 0
                )}
                {buildVerticalDivider()}
                {buildStationPinStatus(
                  ChargeConstants.ChargeStationStatus.MAINTAINING,
                  _.countBy(socData?.stations, 'status')?.[
                  ChargeConstants.ChargeStationStatus.MAINTAINING
                  ] ?? 0
                )}
                {buildVerticalDivider()}
                {buildStationPinStatus(
                  ChargeConstants.ChargeStationStatus.HIDDEN,
                  _.countBy(socData?.stations, 'status')?.[
                  ChargeConstants.ChargeStationStatus.HIDDEN
                  ] ?? 0
                )}
                {buildVerticalDivider()}
                {buildStationPinStatus(
                  ChargeConstants.ChargeStationStatus.PENDING,
                  _.countBy(socData?.stations, 'status')?.[
                  ChargeConstants.ChargeStationStatus.PENDING
                  ] ?? 0
                )}
                {buildVerticalDivider()}
                {buildStationPinStatus(
                  ChargeConstants.ChargeStationStatus.DISCONNECTED,
                  _.countBy(socData?.stations, 'status')?.[
                  ChargeConstants.ChargeStationStatus.DISCONNECTED
                  ] ?? 0
                )}
                {buildVerticalDivider()}
                {buildStationPinStatus(
                  ChargeConstants.ChargeStationStatus.STOPPED,
                  _.countBy(socData?.stations, 'status')?.[
                  ChargeConstants.ChargeStationStatus.STOPPED
                  ] ?? 0
                )}
              </div>
            </div>
            <div className="row m-0 p-0 px-2" style={{ pointerEvents: 'visible' }}>
              <div className="col-4 px-2">
                <div
                  ref={pointChartRef}
                  className="w-100"
                // style={{
                //   aspectRatio: '357/197',
                // }}
                >
                  {buildSocCard(
                    <div>
                      {buildSocCardTitle('Tình trạng hoạt động trụ sạc')}
                      <div
                        className="w-100 d-flex"
                        style={{
                          gap: `${windowSize.width * 0.008}px`,
                        }}
                      >
                        <div
                          className="mt-4"
                          style={{
                            width: `${windowSize.width * 0.066}px`,
                            aspectRatio: '1/1',
                          }}
                        >
                          {pointChartEl}
                        </div>
                        <div className="d-flex flex-column justify-content-center gap-5px">
                          {buildChartPointStatus(
                            ChargeConstants.ChargePointStatus.AVAILABLE,
                            pointStatistic?.[ChargeConstants.ChargePointStatus.AVAILABLE]
                          )}
                          {buildChartPointStatus(
                            ChargeConstants.ChargePointStatus.BUSY,
                            pointStatistic?.[ChargeConstants.ChargePointStatus.BUSY]
                          )}
                          {buildChartPointStatus(
                            ChargeConstants.ChargePointStatus.MAINTAINING,
                            pointStatistic?.[ChargeConstants.ChargePointStatus.MAINTAINING]
                          )}
                          {buildChartPointStatus(
                            ChargeConstants.ChargePointStatus.FAULT,
                            pointStatistic?.[ChargeConstants.ChargePointStatus.FAULT]
                          )}
                          {buildChartPointStatus(
                            ChargeConstants.ChargePointStatus.DISCONNECTED,
                            pointStatistic?.[ChargeConstants.ChargePointStatus.DISCONNECTED]
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="col-8 px-2">
                <div className="w-100"
                  style={{
                    height: `${pointChartRef?.current?.offsetHeight}px`
                  }}
                >
                  {buildSocCard(
                    <div>
                      <div
                        ref={notificationTitleRef}
                        style={{
                          padding: `${windowSize.width * 0.006}px`,
                        }}
                      >
                        {buildSocCardTitle('Thông báo')}
                      </div>
                      {/* danh sach thong bao */}
                      <div
                        className="overflow-auto"
                        style={{
                          maxHeight: `${pointChartRef?.current?.offsetHeight - notificationTitleRef?.current?.offsetHeight}px`,
                          overflowY: "auto",
                          scrollbarWidth: 'none',
                          msOverflowStyle: 'none',
                        }}
                      >
                        {systemLogList?.map((row, index) => {
                          return <div key={index}>{buildMessageLogItem(row, index < 2)}</div>;
                        })}
                      </div>
                    </div>,
                    false,
                    true
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* right - bieu do he thong */}
          <div
            className="h-100 d-flex flex-column"
            style={{
              width: `${windowSize.width * 0.19}px`,
              pointerEvents: 'visible',
            }}
          >
            <div
              className="position-relative w-100"
              style={{
                aspectRatio: '342/39',
              }}
            >
              <img
                src={imgSocTopRight}
                alt="decor-top-right"
                className="w-100 h-100"
                style={{
                  objectFit: 'contain',
                }}
              />
              <div
                className="position-absolute right-0 top-0 h-100 d-flex align-items-center"
                style={{
                  paddingBottom: '0.5%',
                  paddingRight: '5%',
                }}
              >
                <span
                  className="text-uppercase"
                  style={UIHelper.buildFontStyle('700', `${windowSize.width * 0.009}px`, 'white')}
                >
                  Biểu đồ hệ thống
                </span>
              </div>
            </div>
            <div
              className="d-flex flex-column justify-content-between h-100"
              style={{
                paddingTop: `${windowSize.width * 0.008}px`,
                gap: `${windowSize.width * 0.008}px`,
              }}
            >
              <div
                className="d-flex flex-column h-100"
                style={{ gap: `${windowSize.width * 0.008}px` }}
              >
                {/* thong ke phien sac */}
                <div
                  className="w-100 flex-grow-1"
                  style={{
                    height: `${(windowSize.height * 214) / 1080}px`,
                  }}
                >
                  {buildSocCard(
                    <div className="d-flex flex-column h-100">
                      {buildSocCardTitle('Thống kê phiên sạc', 'Phiên')}
                      <div
                        className="flex-grow-1"
                        style={{
                          marginTop: `${windowSize.width * 0.008}px`,
                          height: `${(windowSize.height * 160) / 1080}px`,
                        }}
                      >
                        {chartTransactionByDateEl}
                      </div>
                    </div>
                  )}
                </div>
                {/* thong ke dien sac */}
                <div
                  className="w-100 flex-grow-1"
                  style={{
                    height: `${(windowSize.height * 214) / 1080}px`,
                  }}
                >
                  {buildSocCard(
                    <div className="d-flex flex-column h-100">
                      {buildSocCardTitle('Thống kê điện sạc', 'kWh')}
                      <div
                        className="flex-grow-1"
                        style={{
                          marginTop: `${windowSize.width * 0.008}px`,
                          height: `${(windowSize.height * 160) / 1080}px`,
                        }}
                      >
                        {chartEnergyByDateEl}
                      </div>
                    </div>
                  )}
                </div>
                {/* thong ke doanh thu */}
                <div
                  className="w-100 flex-grow-1"
                  style={{
                    height: `${(windowSize.height * 214) / 1080}px`,
                  }}
                >
                  {buildSocCard(
                    <div className="d-flex flex-column h-100">
                      {buildSocCardTitle('Thống kê doanh thu', 'VNĐ')}
                      <div
                        className="flex-grow-1"
                        style={{
                          marginTop: `${windowSize.width * 0.008}px`,
                          height: `${(windowSize.height * 160) / 1080}px`,
                        }}
                      >
                        {chartRevenueByDateEl}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {/* thong ke loai xe */}
              <div className="w-100" style={{ aspectRatio: '358/152' }}>
                {buildSocCard(
                  <div>
                    {buildSocCardTitle('Thống kê loại xe')}
                    <div
                      className="w-100 d-flex align-items-center justify-content-around"
                      style={{
                        gap: `${windowSize.width * 0.008}px`,
                        paddingTop: `${windowSize.width * 0.008}px`,
                        paddingBottom: `${windowSize.width * 0.008}px`,
                      }}
                    >
                      {buildVehicleStatisticItem(
                        'Tổng xe',
                        Utils.formatNumber(vehicleStatistic.car + vehicleStatistic.bike)
                      )}
                      {buildVerticalDivider(windowSize.width * 0.0427)}
                      {buildVehicleStatisticItem('Ô tô', Utils.formatNumber(vehicleStatistic.car))}
                      {buildVerticalDivider(windowSize.width * 0.0427)}
                      {buildVehicleStatisticItem(
                        'Xe máy',
                        Utils.formatNumber(vehicleStatistic.bike)
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SOCHomeView;
